import { apiClient } from '@/lib/api';
import type { SaveReferenceLabelDto, ReferenceLabelDto } from '@/types/referenceLabels';

const BASE_URL = '/api/v1/tests';

export const referenceLabelService = {
  async getLabels(testId: string): Promise<ReferenceLabelDto[]> {
    const response = await apiClient.get<ReferenceLabelDto[]>(
      `${BASE_URL}/${testId}/reference-labels`
    );
    return response.data;
  },

  async saveLabels(
    testId: string,
    labels: SaveReferenceLabelDto[]
  ): Promise<ReferenceLabelDto[]> {
    const response = await apiClient.post<ReferenceLabelDto[]>(
      `${BASE_URL}/${testId}/reference-labels`,
      { labels }
    );
    return response.data;
  },

  async deleteLabel(testId: string, channelId: number): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${testId}/reference-labels/${channelId}`);
  },
};
